import { render, staticRenderFns } from "./CommentoItem.vue?vue&type=template&id=4936ef21"
import script from "./CommentoItem.vue?vue&type=script&lang=js"
export * from "./CommentoItem.vue?vue&type=script&lang=js"
import style0 from "./CommentoItem.vue?vue&type=style&index=0&id=4936ef21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports